<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<div class="wintersport-wetter-container">
  <h3>Wintersportwetter Werte ({{wintersportWetterWerte?.update}})</h3>
  <mat-card class="wintersportwetter-werte-mat-card" *ngFor="let region of wintersportWetterWerte?.regionen">
    <mat-card-title>{{region.name}}</mat-card-title>
    <mat-card-content class="wintersportwetter-werte-mat-card-content" *ngFor="let gebiet of region.gebiete">
      <span class="wintersportwetter-werte-gebiet-name"><b>{{gebiet.name}}</b></span>
      <div class="wintersportwetter-werte-ort">
        <table>
          <thead>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let ort of gebiet.orte">
            <td>{{ort.name}}</td>
            <td>{{ort.messung.name}}</td>
            <td>{{ort.messung.wert}}</td>
            <td>{{ort.messung.einheit}} |</td>
          </tr>
          </tbody>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
